export interface RtspUrl {
    /** Host for the socket; an IPv6 literal without its brackets. */
    host: string;
    port: number;
    username?: string;
    password?: string;
    /** The URL without credentials, as it is sent in requests. */
    requestUrl: string;
}

export const DEFAULT_RTSP_PORT = 554;

// Not `new URL()`: older engines (Chrome before 130, so a stale Android WebView) do not parse
// host and port of a non-special scheme such as rtsp://.
const PATTERN = /^rtsp:\/\/(?:([^@/?#]*)@)?(\[[^\]]+\]|[^:/?#]+)(?::(\d+))?([/?#].*)?$/i;

export function parseRtspUrl(url: string) : RtspUrl {
    const match = PATTERN.exec(url.trim());
    if (!match) {
        throw new Error('not an rtsp:// URL');
    }

    const [, userinfo, hostPart = '', portText, rest = ''] = match;
    const port = portText === undefined ? DEFAULT_RTSP_PORT : Number(portText);
    if (port < 1 || port > 65_535) {
        throw new Error('invalid port in the RTSP URL');
    }

    const result: RtspUrl = {
        host: hostPart.startsWith('[') ? hostPart.slice(1, -1) : hostPart,
        port,
        requestUrl: `rtsp://${hostPart}${portText === undefined ? '' : `:${portText}`}${rest}`,
    };
    if (userinfo !== undefined && userinfo !== '') {
        const separator = userinfo.indexOf(':');
        result.username = decodeURIComponent(separator < 0 ? userinfo : userinfo.slice(0, separator));
        if (separator >= 0) {
            result.password = decodeURIComponent(userinfo.slice(separator + 1));
        }
    }
    return result;
}

/** Resolves an SDP `a=control` value against the base URL of the description. */
export function resolveControlUrl(base: string, control: string | undefined) : string {
    if (control === undefined || control === '' || control === '*') {
        return base;
    }
    if (/^rtsp:\/\//i.test(control)) {
        return control;
    }
    // Like other clients, append instead of RFC 3986 resolution: cameras expect base + "/" + control.
    return base.endsWith('/') ? base + control : `${base}/${control}`;
}
